// src/models/controleBar/comandas/ComprovantePagComanda.js
import { StatusComanda } from './StatusComanda';

export const selecionarComandasQuitadas = (antes = [], depois = []) => {
  const abertas = new Set(antes.filter(c => Number(c.status) !== StatusComanda.Fechada).map(c => Number(c.id)));
  const encontradas = new Set();
  return depois.filter(c => {
    const id = Number(c.id);
    if (!abertas.has(id) || encontradas.has(id) || Number(c.status) !== StatusComanda.Fechada) return false;
    encontradas.add(id);
    return true;
  });
};
